export default "__VITE_ASSET__BGkfX$db__"